<template>
  <div>
    <div
      id="carouselControlsComponent"
      class="carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <!------- *** 3 SLIDES *** --------->
      <div class="carousel-inner">
        <div>
          <div
            class="carousel-item"
            v-for="(slide, index) in slides"
            :key="slide.id"
            :class="{ active: index === 0 }"
          >
            <h3 class="font-weight-bold">{{ slide.title }}</h3>
            <div class="dflex text-center">
              <img v-if="slide.thumb == 'img-carousel-teste'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-teste.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-campo1'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campo1.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-campo2'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campo2.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-campomembro'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campomembro.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-campoforms'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campoforms.png"
                alt="Teste"
              />

              <img v-else-if="slide.thumb == 'img-carousel-campoues'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campoues.png"
                alt="Teste"
              />

              <img v-else-if="slide.thumb == 'img-carousel-campoturmas'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-campoturmas.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-regional'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-regional.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-municipal'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-municipal.png"
                alt="Teste"
              />

              <img v-if="slide.thumb == 'img-carousel-cargos'"
                class="my-3 img-modal-carousel"
                src="../assets/img/Dados/CarouselsModals/img-carousel-cargos.png"
                alt="Teste"
              />
            </div>
            <p>{{ slide.text }}</p>

            <div
              class="d-flex"
              :class="{
                'justify-content-end': index == 0,
                'justify-content-between': index != 0,
              }">

              <Button
                value="Anterior"
                iconName="chevron-left"
                section="painel-outline"
                :isOutline="true"
                :hasIcon="true"
                :hasShadow="false"
                :class="{'hidden-button': index == 0}"
                href="#carouselControlsComponent"
                data-slide="prev"
              />
              <Button
                value="Próximo"
                iconName="chevron-right"
                section="painel-outline"
                :isOutline="true"
                :hasIcon="true"
                :hasShadow="false"
                :isReverse="true"
                :class="{'hidden-button': index == Object.keys(slides).length - 1}"
                href="#carouselControlsComponent"
                data-slide="next"
              />
              <Button
                value="Concluído"
                iconName="check-circle"
                section="painel-outline"
                :isOutline="true"
                :hasIcon="true"
                :hasShadow="false"
                :class="{'hidden-button': index != Object.keys(slides).length - 1}"
                data-dismiss="modal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./Button";

export default {
  name: "Carousel",

  components: {
    Button,
  },

  props: {
    slides: Object,
  },
};
</script>

<style scoped>

p {
  text-align: justify;
}
.img-modal-carousel {
  width: 70%;
  text-align: center;
}

.hidden-button {
  display: none;
}

.show-button {
  display: inline-block;
}

.align-next {
  display: block;
  justify-self: flex-end !important;
}
</style>
